import ConstructorIORecommendations from '../recommendations';
import ConstructorRecommendations from '../../spa/components/recommendations/recommendations';
import ConstructorUniversalRecommendations from '../../spa/components/recommendations/recommendations-universal';
import wishlist from '../../pages/wishlist';

const cartoverlay = require('../../components/checkout/cartoverlay');
const slickConfigs = require('../../components/slickConfigs');
const crossSell = require('../../components/cross-sell');

/**
 * Get constructor recommendation with their API
 *
 * @param {string} podId - podID in constructor.io
 * @param {Array} itemIds - array of productids
 * @param {number} [maxResults] max number of results
 * @returns {Object} constructor response
 */
export const getConstructorRecommendations = async function (podId, itemIds, maxResults) {
    const constructorIORecommendations = new ConstructorIORecommendations(maxResults);
    const result = await constructorIORecommendations.getRecommendations(podId, itemIds);
    return result;
};

/**
 * Render constructor recommendation (insert then in html)
 *
 * @param {string} podId - podID in constructor.io
 * @param {Array} itemIds - array of productids
 */
export const renderRecommendations = async function (podId, itemIds) {
    const result = await getConstructorRecommendations(podId, itemIds);
    const $recommContainer = $('.js-add-to-cart-recomm-constructor');
    if (result.products?.length) {
        $recommContainer.show();
        $recommContainer.attr('data-cnstrc-num-results', result.products?.length);
        $recommContainer.attr('data-cnstrc-recommendations-pod-id', result.pod_id);
        $recommContainer.attr('data-cnstrc-result-id', result.result_id);
        const recHTML = ConstructorRecommendations(result.products);
        $recommContainer.find('.js-constructor-recommendations-products').html(recHTML);
        $recommContainer.find('.js-add-to-cart-recomm-constructor-title').html(result.pod_display_name);
        cartoverlay.slickRecomm();
    } else {
        $recommContainer.hide();
    }
};

/**
 * Render constructor recommendation universal (insert then in html)
 *
 * @param {Object} recommendationInfo - recommendation info pod_id, selector
 * @param {Array} [itemIds] - array of productids
 */
export const renderRecommendationsUniversal = async function (recommendationInfo, itemIds = []) {
    const maxResults = 16; // max results only for universal recommendations
    const result = await getConstructorRecommendations(recommendationInfo.pod_id, itemIds, maxResults);

    if (result.products?.length) {
        const recHTML = ConstructorUniversalRecommendations(result);
        switch (recommendationInfo.selector_type) {
            case 'insertBefore':
                $(recommendationInfo.selector).before(recHTML);
                break;
            case 'insertAfter':
            default:
                $(recommendationInfo.selector).after(recHTML);
                break;
        }
    }
};

/**
 * Init universal recommedations
 *
 * @param {string} pageType  homepage, product...
 */
export const initUniversalRecommendations = async function (pageType) {
    const constructorRecommendations = window.SitePreferences.CONSTRUCTOR_UNIVERSAL_RECOMMENDATIONS;
    if (!window.CONSTRUCTOR_API_KEY) return;
    if (constructorRecommendations?.length) {
        let productIds = [];
        if (pageType === 'product') {
            const productData = $('.product-content-top').data();
            productIds = [productData.cnstrcItemId];
        }

        constructorRecommendations.forEach(async recommendationInfo => {
            if (recommendationInfo.page_type === pageType) {
                if (recommendationInfo.url_includes) {
                    const urlIncludesParts = recommendationInfo.url_includes.split(',');
                    const url = window.location.href.toLowerCase();
                    const notIncluded = urlIncludesParts.some(part => !url.includes(part.trim().toLowerCase()));
                    if (notIncluded) {
                        return;
                    }
                }
                await renderRecommendationsUniversal(recommendationInfo, productIds);
                slickConfigs.universalSlickRecomm();
                wishlist.init();
            }
        });
    }
};

/**
 * Remove universal recommendations
 */
export const removeUniversalRecommendations = function () {
    $('.js-universal-recommendations').remove();
};

/**
 * Render cross sell product from constructor
 *
 * @param {JQuery} $crossSellContainer container for the product
 * @param {string} podId podId of the recommendation in constructor
 * @param {Array} itemIds products ids from cart to send to constructor, variation group id used if possible
 */
const renderCrossSellCart = async function ($crossSellContainer, podId, itemIds) {
    const result = await getConstructorRecommendations(podId, itemIds);
    if (result?.products?.length) {
        const recProduct = result.products[0];
        const formattedPrice = recProduct.priceInfo?.minPrice;
        const additionalInfo = recProduct.priceInfo?.additionalInfo;
        const {comparePriceString} = recProduct;
        let priceDetail = ''; // price per ml
        const imgUrl = recProduct.image?.url;
        $crossSellContainer.find('.js-cross-sell-cart-title').html(result.pod_display_name);
        $crossSellContainer.find('.js-cross-sell-product-modelname').html(recProduct.modelName);
        $crossSellContainer.find('.js-cross-sell-product-shortname').html(recProduct.shortName);
        $crossSellContainer.find('.js-cross-sell-product-colorname').html(recProduct.colorName);
        $crossSellContainer.attr('data-cnstrc-num-results', result.products?.length);
        $crossSellContainer.attr('data-cnstrc-recommendations-pod-id', result.pod_id);
        $crossSellContainer.attr('data-cnstrc-result-id', result.result_id);
        const $crossSellProductContainer = $crossSellContainer.find('.js-cross-sell-product');

        $crossSellProductContainer.attr('data-cnstrc-item-id', recProduct.ID);
        $crossSellProductContainer.attr('data-cnstrc-item-name', recProduct.name);
        $crossSellProductContainer.attr('data-cnstrc-item-variation-id', recProduct.variationId);
        $crossSellProductContainer.attr('data-cnstrc-strategy-id', recProduct.strategyId);
        $crossSellProductContainer.attr('data-cnstrc-item-price', recProduct.priceInfo?.salePriceValue);
        if (formattedPrice) {
            $crossSellContainer.find('.js-cross-sell-product-formatted-price').html(formattedPrice);
            if (additionalInfo) {
                priceDetail = `${formattedPrice} / ${additionalInfo}`;
                $crossSellContainer.find('.js-cross-sell-product-additional-info').html(priceDetail);
            }
        }
        if (comparePriceString && comparePriceString !== priceDetail) {
            $crossSellContainer.find('.js-cross-sell-product-compare-price').html(comparePriceString);
        }
        if (imgUrl) {
            $crossSellContainer
                .find('.js-cross-sell-product-image')
                .html(`<img src="${imgUrl}" alt="${recProduct.name}" />`);
        }
        const $addToCartButton = $crossSellContainer.find('.js-rec-add-to-cart');
        $addToCartButton.attr('data-pid', recProduct.variationId);
        $addToCartButton.attr('data-price', recProduct.priceInfo?.salePriceValue);
        $addToCartButton.attr('data-variationname', recProduct.name);
        $addToCartButton.attr('data-productid', recProduct.ID);

        // for 3 -cosmetics, 7- shoecare, add product directly to cart, otherwise open quickshop flyin to choose width and size
        if (recProduct.mainProductGroup !== 3 && recProduct.mainProductGroup !== 7) {
            $addToCartButton.attr('data-show-quickshop', true);
        } else {
            $addToCartButton.attr('data-cnstrc-btn', 'add_to_cart');
        }

        if (recProduct.swatches) {
            const {swatches} = recProduct;
            const selectedSwatch = swatches.find(swatch => swatch.preselectCurrentSwatch === true);
            if (selectedSwatch) {
                $addToCartButton.attr('data-color', selectedSwatch.colorID);
            }
            if (swatches.length && swatches.length > 1) {
                const swatchesHtml = recommedationSwatches(swatches);
                const $swatchesContainer = $crossSellContainer.find('.js-cross-sell-swatches');
                const $crossSellImage = $crossSellContainer.find('.cross-sell-cart-image');
                $crossSellImage.addClass('expanded');
                $swatchesContainer.html(swatchesHtml);
                $swatchesContainer.on('click', '.js-cross-sell-swatch', event => {
                    const $currentElement = $(event.currentTarget);
                    const swatchProductId = $currentElement.data('swatchProductId');
                    const swatchInfo = swatches.find(swatch => swatch.productID === swatchProductId);
                    let swatchPriceInfo = {};
                    try {
                        swatchPriceInfo = JSON.parse(swatchInfo.priceInfo);
                    } catch (err) {
                        swatchPriceInfo = {};
                    }
                    if (swatchPriceInfo.minPrice) {
                        $crossSellContainer
                            .find('.js-cross-sell-product-formatted-price')
                            .html(swatchPriceInfo.minPrice);
                    }
                    $crossSellContainer.find('.js-cross-sell-product-colorname').html(swatchInfo.colorName);
                    $crossSellContainer
                        .find('.js-cross-sell-product-image')
                        .html(`<img src="${swatchInfo.thumbImage?.url}" alt="${swatchInfo.thumbImage?.title}" />`);

                    $addToCartButton.attr('data-productid', swatchProductId);
                    $swatchesContainer.find('.js-cross-sell-swatch').removeClass('current');
                    $currentElement.addClass('current');
                });
            }
        }
        $crossSellContainer.removeClass('hidden');
    }
};

/**
 * Render recommendation swatches
 *
 * @param {Array} swatches swatches array
 * @returns {string} html
 */
function recommedationSwatches(swatches) {
    if (!swatches) return '';
    return `<div>${swatches
        .map(
            swatch => `
            <div class="js-cross-sell-swatch cross-sell-cart-swatch ${
                swatch.preselectCurrentSwatch ? 'current' : ''
            } " data-swatch-product-id="${swatch.productID}">
                <img width="69" height="58" src="${swatch.thumbImage.url}" />
            </div>
        `
        )
        .join('')}</div>
        `;
}

/**
 * Init rendering cross sell product from constructor, if we find the dom element then constructor recommendations are enabled
 */
export const initConstructorCrossSell = function () {
    const $crossSellContainer = $('.js-cross-sell-constructor');
    if ($crossSellContainer.length > 0) {
        crossSell.init();
        const productIds = $crossSellContainer.data('productIds').toString().split(',');
        if (productIds && productIds.length) {
            renderCrossSellCart($crossSellContainer, 'cross-sell-module', [productIds[0]]);
        }
    }
};
